<mat-icon
  #trigger="cdkOverlayOrigin"
  class="material-icons-outlined"
  cdkOverlayOrigin
  [ngStyle]="style"
  (mouseenter)="show()"
  (mouseleave)="hide()">
  info
</mat-icon>
<ng-template
  cdk-connected-overlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isVisible"
  [cdkConnectedOverlayPositions]="overlayPosition"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayFlexibleDimensions]="true">
  <div class="tooltip">
    @if (text) {
      <p class="cms-external-content">{{ text | translate }}</p>
    }
    @if (html) {
      <p
        class="cms-external-content"
        [innerHtml]="html"></p>
    }
    <p class="cms-external-content">
      @if (template) {
        <ng-template [ngTemplateOutlet]="template"></ng-template>
      }
    </p>
  </div>
</ng-template>
